import { createContext, useContext, useState, useEffect } from 'react';
import { de } from '../translations/de';
import { en } from '../translations/en';

const translations = { de, en };

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => {
    return localStorage.getItem('hc-lang') || 'de';
  });

  const switchLang = (newLang) => {
    setLang(newLang);
    localStorage.setItem('hc-lang', newLang);
  };

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  return (
    <LanguageContext.Provider value={{ lang, switchLang, t: translations[lang] }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error('useLanguage must be used within LanguageProvider');
  return ctx;
}
